<template>
  <div class="sw-ts-root">
    <v-autocomplete
      :value="normalizedValue"
      :items="selectItems"
      item-value="value"
      item-text="text"
      :loading="loading"
      :disabled="disabled"
      :label="compact ? '' : fieldLabel"
      :placeholder="fieldLabel"
      :dense="compact"
      hide-details
      :hide-no-data="false"
      :menu-props="{ contentClass: 'sw-ts-menu' }"
      :class="compact ? 'sw-ts-autocomplete sw-ts-compact' : 'sw-ts-autocomplete sw-ts-outlined'"
      :solo="compact"
      :flat="compact"
      :outlined="!compact"
      clearable
      @input="onInput"
    >
      <template v-slot:append-item>
        <v-divider />
        <v-list-item
          class="sw-ts-add-item"
          @click.stop="openCreateDialog"
        >
          <v-list-item-icon class="mr-2">
            <v-icon color="#0091d5" size="22">mdi-account-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="sw-ts-add-title">
              {{ $t('FieldSurveyForm.addTechnician') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>

    <survey-work-new-technician-dialog
      v-model="createDialog"
      @created="onTechnicianCreated"
    />
  </div>
</template>

<script>
import SurveyWorkNewTechnicianDialog from './SurveyWorkNewTechnicianDialog.vue'
import { PONCE_TECHNICIAN_SELECT_VALUE } from '@/lib/surveyWorkTechnicians'

export default {
  name: 'SurveyWorkTechnicianSelect',
  components: { SurveyWorkNewTechnicianDialog },
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /** Solo-style (sidebar cards); false = outlined (map popup) */
    compact: {
      type: Boolean,
      default: true
    },
    fieldSurveyId: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      createDialog: false
    }
  },
  computed: {
    fieldLabel () {
      return this.labelKey ? this.$t(this.labelKey) : this.$t('FieldSurveyForm.fieldUser')
    },
    selectItems () {
      const ponce = {
        value: PONCE_TECHNICIAN_SELECT_VALUE,
        text: this.$t('FieldSurveyForm.ponceTechnicianOption')
      }
      return [ponce, ...this.items]
    },
    normalizedValue () {
      return this.value == null ? '' : this.value
    }
  },
  methods: {
    onInput (v) {
      this.$emit('input', v == null ? '' : v)
    },
    openCreateDialog () {
      this.createDialog = true
    },
    onTechnicianCreated ({ id, name, lastName }) {
      this.$emit('input', id)
      this.$emit('user-created', { id, name, lastName })
    }
  }
}
</script>

<style scoped lang="stylus">
.sw-ts-root
  width 100%

.sw-ts-compact
  margin-top 0

.sw-ts-outlined
  margin-top 0
  font-size 0.8125rem

.sw-ts-add-item
  min-height 44px !important
  border-top 1px solid #eee
  position sticky
  bottom 0
  background #fff !important
  z-index 2

.sw-ts-add-title
  color #0091d5
  font-weight 600
  font-size 0.875rem
</style>

<style lang="stylus">
/* Dropdown menu width follows autocomplete */
.sw-ts-menu
  .v-list-item
    min-height 40px
</style>



// WEBPACK FOOTER //
// SurveyWorkTechnicianSelect.vue?305bb9f7